import React from 'react'
import '../../../client/theme.scss'
import '../../../client/app.scss'
import '../../../client/swiper.bundle.scss'

import { renderRoutes } from 'react-router-config'
import routes from '../../../routes/me'

import { IntlProvider } from 'react-intl'
import { getMessage, getLocale } from '../../../i18n'

import { useSelector } from 'react-redux'
import UserLayout from '../../../client/pages/me/layout/user-layout'


import SwiperCore, {
	Pagination,
	Autoplay
} from 'swiper'

SwiperCore.use([Pagination, Autoplay])

const Index = props => {

	const global = useSelector((state) => state.global)

	return <IntlProvider messages={getMessage(global.language)} locale={getLocale(global.language)} defaultLocale="en">
        <UserLayout>
			{renderRoutes(routes)}
		</UserLayout>


		<div id="alert-container"></div>
		<div id="confirm-container"></div>
		<div id="toast-container"></div>
	</IntlProvider>

}


export default Index